import styled from 'styled-components';
import { getRelativeWidth } from '../../config';

interface TitleProps {
    animationDelay?: number | undefined;
}

const PageTitleWrapper = styled.div<TitleProps>`
    position: absolute;
    top: 0rem;
    opacity: 0;
    animation: slideInAnimation 0.2s ease-in-out ${(props) => props.animationDelay || 0}s forwards;
    @keyframes slideInAnimation {
        0% {
            top: -3rem;
            opacity: 0;
        }
        100% {
            top: 0rem;
            opacity: 1;
        }
    }
    svg {
        width: auto;
        filter: drop-shadow(0 0.5rem 0.5rem rgba(0, 0, 0, 0.15));
    }

    div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;

        color: white;
        padding: 0 1.5rem 1.3rem 3.5rem;
        font-size: 1.5rem;
        align-items: center;
        box-sizing: border-box;
    }
`;

export function PageTitle(props: { width: number; children: any; animationDelay?: number | undefined }) {
    const offset = props.width - 406;
    return (
        <PageTitleWrapper animationDelay={props.animationDelay} style={{width: `${getRelativeWidth(props.width)}rem`}}>
            <svg width={`${getRelativeWidth(props.width)}rem`} height='3.8rem' viewBox={`0 10 ${460 + offset} 70`}>
                <path
                    d={`M${offset + 451.18},-2L${offset + 411.887},60C${offset + 410.84},61.5 ${offset + 408.224},63 ${
                        offset + 406.101
                    },63L-3,63L-3,-2L${offset + 451.18},-2Z`}
                    strokeWidth={4}
                    stroke='#fff'
                    fill='url(#_Linear1)'
                />
                <defs>
                    <linearGradient id='_Linear1' x1='0' y1='0' x2='1' y2='0'>
                        <stop stopColor='#004485' offset='0%'></stop>
                        <stop stopColor='#04B7EC' offset='100%'></stop>
                    </linearGradient>
                </defs>
            </svg>
            <div>{props.children}</div>
        </PageTitleWrapper>
    );
}
